export default "__VITE_ASSET__DSvQw5Ej__"